export default '/static/frontend/ReachDigital/12gobiking/dist/assets/cartesbancaires-4c65ad4d.jpg'